import {Injector, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {PriceComponent_Catalogue} from "./price.component";
import {ContentloaderModule} from '@signature-it/ngx-generic/components/contentloader';
import { TooltipModule } from "ngx-bootstrap/tooltip";
import {createCustomElement} from "@angular/elements";
import {SafePipeModule, ReplaceTokensPipeArrayModule} from "@signature-it/ngx-generic/pipes";

@NgModule({
    declarations: [
        PriceComponent_Catalogue
    ],
    imports: [
        CommonModule,
        TranslateModule,
        ContentloaderModule,
        SafePipeModule,
        ReplaceTokensPipeArrayModule,
        TooltipModule.forRoot()
    ],
    exports: [PriceComponent_Catalogue]
})
export class PriceModule_Catalogue {
    constructor(private injector: Injector) {
        const PriceComp = createCustomElement(PriceComponent_Catalogue, {injector});
        !customElements.get('ngx-price') && customElements.define('ngx-price', PriceComp);
    }
}
